import {Component, Input} from '@angular/core';

@Component({
    selector: 'wba-accordion',
    templateUrl: './accordion.component.html',
    standalone: false
})
export class AccordionComponent {
  @Input() accordionTitle: string;
  @Input() subtitle: string;
  @Input() id: string;
}
